import './bootstrap'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import mainStore from './store'
import {VueTables, ServerTable, ClientTable, Event} from 'vue-tables-2';
import VueToastr from '@deveodk/vue-toastr'
import {Pagination} from 'vue-pagination-2';
import VueMask from 'v-mask'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import CKEditor from '@ckeditor/ckeditor5-vue';

const translation = {
    count: 'Mostrando {from} de {to} até {count} de registros',
    filter: 'Pesquisar:',
    filterPlaceholder: 'Pesquisar',
    limit: 'Registros:',
    noResults: 'Nenhum registro encontrado',
    page: 'Página:',
    // for dropdown pagination filterBy: 'Filter by {column}',
    // Placeholder for search fields when filtering by column loading:'Loading...',
    // First request to server defaultOption:'Select {column}'
    // default option for list filters }
}

const options = {
    requestFunction: function (data) {
        // data.token = this.$store.getters.token
        return axios.get(this.url, {
            params: data
        }).catch(function (e) {
            this.dispatch('error', e);
            router.push('/login')
        }.bind(this));
    },
    texts: translation,
    pagination: {chunk: 15, dropdown: false, nav: 'scroll'},
    perPage: 10,
    perPageValues: [10, 25, 50, 100]
}

Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(router)
Vue.use(ServerTable, options, true, 'bootstrap3', 'footerPagination')
Vue.use(VueToastr)
Vue.use(VueMask);
Vue.use(require('vue-moment'));
Vue.use(CKEditor);

Vue.component('date-time', VueCtkDateTimePicker);

export const store = new Vuex.Store(mainStore);

import 'vue-select/dist/vue-select.css';
import moment from 'moment';
window.moment = moment

Vue.prototype.$secondsToTimeFormated = function (seconds) {
  var hours = Math.floor(seconds / 60 / 60);
  var minutes = Math.floor(seconds / 60) - (hours * 60);
  var seconds = seconds % 60;

  var formatted = hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');

  return formatted
};

Vue.filter('dateTime', function (datetime) {
  return moment(datetime).format('DD/MM/YYYY HH:mm:ss')
})

Vue.filter('dateTimeDiff', function (start, end) {
  let startMoment = moment(start)
  let endMoment = moment(end)

  let duration = moment.duration(endMoment.diff(startMoment));

  let seconds = duration.asSeconds();

  return seconds

})

Vue.filter('formatSeconds', function (seconds) {
  var hours = Math.floor(seconds / 60 / 60);
  var minutes = Math.floor(seconds / 60) - (hours * 60);
  var seconds = seconds % 60;

  var formatted = hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');

  return formatted
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>',
    created() {
        this.$store.dispatch('initialize')
    },
});

/*
  <link rel="stylesheet" href="src/assets/auxiliary/bootstrap/css/bootstrap.min.css">
    <link rel="stylesheet" href="src/assets/css/style.css">
    <link rel="stylesheet" href="src/assets/auxiliary/animate/animate.css">
    <link rel="stylesheet" href="src/assets/auxiliary/fontawesome/css/all.min.css">
*/

window.$ = require('jquery')
window.JQuery = require('jquery')
window.moment = require('moment')

import './assets/auxiliary/bootstrap/css/bootstrap.min.css'
require('bootstrap') 
import '../node_modules/@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'
import './assets/css/style.css'
import './assets/auxiliary/animate/animate.css'
import './assets/auxiliary/fontawesome/css/all.min.css'
import swal from 'sweetalert'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

Vue.prototype.$http = window.axios;
Vue.prototype.$message = function (title, msg, type) {

    let newMsg = '';
    if(msg instanceof Object){

        newMsg += "<ul>";
        for (var key in msg) {
            if (msg.hasOwnProperty(key)) {
                newMsg += "<li>";
                newMsg += msg[key];
                newMsg += "</li>";
            }
        }
        newMsg += "</ul>";

    } else newMsg = msg;

    this.$toastr('add',
        {
            title: title,
            msg: newMsg,
            clickClose: true,
            timeout: 4000,
            position: 'toast-top-right',
            type: type
        })
};



// WEBPACK FOOTER //
// ./src/main.js